import { forwardRef, ReactNode } from 'react';
import classNames from 'classnames';
import * as styles from './CarouselContent.module.scss';

type CarouselContentProps = {
  children: ReactNode;
  className?: string;
  variant?: 'product' | 'review';
};

const containerListId = 'carousel-container-scroll';

const CarouselContent = forwardRef<HTMLDivElement, CarouselContentProps>(
  function ForwardedCarouselContent({ className, children, variant }, ref) {
    const wrapperStyles = classNames(
      styles.container,
      {
        [styles.productCarousel]: variant === 'product',
        [styles.reviewCarousel]: variant === 'review',
      },
      className,
    );

    return (
      <div className={wrapperStyles} ref={ref} data-testid={containerListId}>
        {children}
      </div>
    );
  },
);

export { CarouselContent };
